import React from "react";

const VerticalSpace = ({ size = "my-3" }) => {
  return <span className={`block w-full ${size}`} />;
};

export default VerticalSpace;
